var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbisoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.1 80",
    style: {
      enableBackground: "new 0 0 85.1 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-424.86898,-1751.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3049",
    className: "testimonial",
    d: "M465.6,1762c-18.6,0-26.7,16.6-26.7,16.6l2.4,1.7c0,0-3,5.7-2.9,12.9 c0,14.8,11.8,28.8,29.2,28.8c15.8,0,28.8-12.9,28.8-28.8C496.4,1772.5,480.3,1762,465.6,1762L465.6,1762z M465.8,1767 c14.6,0,25.8,11.7,25.8,25.4c0,14.5-10.9,24.5-23.5,24.5c-9.3,0-17.7-7.1-17.7-16.8c0-5.6,3-9.5,6.3-11.6l0.5,0.5 c-0.9,0.7-3.5,4.9-3.5,9c0,7.7,6,13,13.6,13c9.6,0,16.1-8.2,16.1-17.8c0-11.1-9.8-20.5-21.6-20.5c-6.5,0-12.1,2.8-15.2,5.3 l-0.5-0.4C450.1,1771.1,457.3,1767,465.8,1767L465.8,1767z M461.4,1777.7c7.5,0,14.9,5,16.7,12.1l-0.7,0.3c-3.3-4.4-8.7-8-15.1-8 c-11.7,0-17.9,10.7-17,19.6l-0.7,0.3c0,0-1.3-2.9-1.3-6.2C443.4,1785.8,451.5,1777.7,461.4,1777.7L461.4,1777.7z M466.4,1790 c3.6,0,6.4,2.9,6.4,6.3c0,2.8-1.8,4.5-1.8,4.5l2.2,1.5c0,0-2.1,3.4-6.5,3.4c-4.2,0-7.9-3.4-7.9-7.9 C458.8,1793.1,462.8,1790,466.4,1790L466.4,1790z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbisoft);
export default __webpack_public_path__ + "static/media/ubisoft.29e28b288e0974528f73a67e07262f37.svg";
export { ForwardRef as ReactComponent };